import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

const WebUserSchema = z.object({
  regNo: z.string().optional().default(''),
  access: z.enum(['YES', 'NO', 'OWN_CAR_ONLY']).default('YES'),
  filterAccess: z.array(z.string()).default([]),
  message: z.string().optional().default(''),
})

const DriverBaseSchema = z.object({
  name: z.string().min(1, 'Navn er påkrevd'),
  jobTitle: z.string().optional(),
  contactType: z.string().optional(),
  mail: z.string().min(1, { message: 'E-post er påkrevd' }).email({ message: 'Ugyldig e-post, må inneholde @' }),
  phoneNo: z.string().regex(/^\d{8}$/, 'Påkrevd, må bestå av 8 tall'),
  address: z.string().optional(),
  city: z.string().optional(),
  postCode: z.string().optional(),
  regNo: z.string().optional().default(''),
  isWebUser: z.boolean().default(false),
  webUser: WebUserSchema.default({
    regNo: '',
    access: 'YES',
    filterAccess: [],
    message: '',
  }),
})

export const DriverCreateSchema = DriverBaseSchema.superRefine((data, ctx) => {
    if (data.isWebUser) {
      if (data.webUser.access === 'OWN_CAR_ONLY' && !data.webUser.regNo.trim()) {
        ctx.addIssue({ code: 'custom', path: ['webUser', 'regNo'], message: 'Regnr (webbruker) er påkrevd' })
      }
      if (!data.webUser.message.trim()) {
        ctx.addIssue({ code: 'custom', path: ['webUser', 'message'], message: 'Melding er påkrevd' })
      }
    }
  })

export const DriverEditSchema = DriverBaseSchema

export type DriverFormValues = z.infer<typeof DriverBaseSchema>
export const DriverCreateValidation = zodResolver(DriverCreateSchema)
export const DriverEditValidation = zodResolver(DriverEditSchema)
